// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "div > .ant-select-selection {\n  border: 1px solid #353535 !important;\n}\n", "",{"version":3,"sources":["webpack://./src/components/AdminExport/Filter/Antd.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;AACtC","sourcesContent":["div > .ant-select-selection {\n  border: 1px solid #353535 !important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
